import { Button, DropZone, LoaderPage, ModelViewer, Stopwatch } from '@sloyd/ui';
import { invokeEvent } from 'shared-base';
import ImageSelector from '../ImageSelector/ImageSelector';
import type { ContentImageTo3dProps } from './ContentImageTo3d';
import { Actions, Column, SmallCanvas } from './ContentImageTo3d.style';

export function PartProgress(props: ContentImageTo3dProps) {
  const { tsStart } = props;

  return (
    <Column className='progress'>
      <Stopwatch ts={tsStart} />
      {tsStart ? (
        <LoaderPage noFlex color='pink'>
          This may take up to 2 minutes <br />
          {/* You can keep using the webapp while we work */}
        </LoaderPage>
      ) : null}
    </Column>
  );
}

export function PartDownload(props: ContentImageTo3dProps) {
  const { externalGlb, callbacks } = props;

  return (
    <Column className='download'>
      <SmallCanvas>{externalGlb ? <ModelViewer glb={externalGlb} /> : null}</SmallCanvas>
      <Actions>
        {/* <Button
          disabled={!externalGlb}
          onClick={() => callbacks.onDownload(externalGlb)}
          variant='outline'
        >
          Transform to Generator 👑
        </Button> */}
        <Button
          disabled={!externalGlb}
          onClick={() => callbacks.onDownload(externalGlb)}
          size='lg'
          variant='gradient'
          gradient={{ from: '#fc4a1a', to: '#f7b733' }}
        >
          Download GLB
        </Button>
      </Actions>
    </Column>
  );
}

export function PartUpload(props: ContentImageTo3dProps) {
  const { credits, callbacks } = props;

  const notEnoughCredits = typeof credits !== 'undefined' && credits < 3;

  function onSelect(url: string) {
    invokeEvent('DropZone', { url });
  }

  return (
    <Column className='upload'>
      <DropZone disabled={notEnoughCredits} onGenerate={callbacks.onGenerate} />
      <ImageSelector onSelect={onSelect} />
    </Column>
  );
}

export const stageToComponent: any = {
  progress: PartProgress,
  download: PartDownload,
  upload: PartUpload,
};
